import { Alert, Button, CopyButton, Group, Modal, Stack, Text } from '@mantine/core'
import { IconCheck, IconCopy } from '@tabler/icons-react'

/**
 * A key em texto de criar/rotacionar, mostrada uma única vez (spec 2026-10-16). O segredo
 * vive só no `data` da mutação de quem chama; `onClose` deve chamar `reset()` para ele sumir.
 * Usado pelo detalhe do gateway e pela visão da organização em WhatsApi → API Keys.
 */
export function ChaveRevelada({ segredo, nome, onClose }: { segredo: string | null; nome: string; onClose: () => void }) {
  return (
    <Modal opened={segredo != null} onClose={onClose} title={`Chave "${nome}"`} closeOnClickOutside={false}>
      <Stack>
        <Alert color="yellow" variant="light">
          Copie agora: esta chave não será mostrada de novo. Quem a tiver envia mensagens pelo número deste gateway.
        </Alert>
        <Text ff="monospace" size="sm" style={{ wordBreak: 'break-all' }} data-testid="chave-em-texto">{segredo}</Text>
        <Group>
          <CopyButton value={segredo ?? ''}>
            {({ copied, copy }) => (
              <Button variant="light" leftSection={copied ? <IconCheck size={14} /> : <IconCopy size={14} />} onClick={copy}>
                {copied ? 'Copiada' : 'Copiar'}
              </Button>
            )}
          </CopyButton>
          <Button onClick={onClose}>Já guardei</Button>
        </Group>
      </Stack>
    </Modal>
  )
}
